// import type { Plugin } from 'vue'

/**
 *
 * @param component 需要注册的组件
 * @param alias 组件别名
 * @returns any
 */
export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: any) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

/**
 * @param str 防抖函数
 * @returns ———
 */
export const debounce = (fn, delay) => {
  let timer
  return ((...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.call(this, args)
    }, delay)
  })()
}

/**
 * @param str 需要转下划线的驼峰字符串
 * @returns 字符串下划线
 */
export const humpToUnderline = (str: string): string => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase()
}

/**
 * @param str 需要转驼峰的下划线字符串
 * @returns 字符串驼峰
 */
export const underlineToHump = (str: string): string => {
  if (!str) return ''
  return str.replace(/\-(\w)/g, (_, letter: string) => {
    return letter.toUpperCase()
  })
}

export const setCssVar = (prop: string, val: any, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}

/**
 * 查找数组对象的某个下标
 * @param {Array} ary 查找的数组
 * @param {Functon} fn 判断的方法
 */
// eslint-disable-next-line
export const findIndex = <T = Recordable>(ary: Array<T>, fn: Fn): number => {
  if (ary.findIndex) {
    return ary.findIndex(fn)
  }
  let index = -1
  ary.some((item: T, i: number, ary: Array<T>) => {
    const ret: T = fn(item, i, ary)
    if (ret) {
      index = i
      return ret
    }
  })
  return index
}

export const trim = (str: string) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @param {Date | number | string} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time: Date | number | string, fmt: string) {
  if (!time) return ''
  else {
    const date = new Date(time)
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  }
}

/**
 * 生成随机字符串
 */
export function toAnyString() {
  const str: string = 'xxxxx-xxxxx-4xxxx-yxxxx-xxxxx'.replace(/[xy]/g, (c: string) => {
    const r: number = (Math.random() * 16) | 0
    const v: number = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString()
  })
  return str
}
/**
 * 获取地址栏参数
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url: string) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}



/**
 *  判断对象中是否存在某个属性,对象,自带函数原型链
 *  @param {Object} obj 对象
 *  @param {String} key 属性名
 *  @return {Boolean} 判断的结果
 */

export function hasProperty(obj: object, key: string) {
  return key in obj
}

export function exportFile(data: any, type: string, fileName: string) {
  const blob = new Blob([data], {
    // type类型后端返回来的数据中会有，根据自己实际进行修改
    // 表格下载为 application/xlsx，压缩包为 application/zip等，
    type: type
  })
  const filename = fileName
  const nav = window.navigator as any
  if (typeof nav.msSaveBlob !== 'undefined') {
    nav.msSaveBlob(blob, filename)
  } else {
    const blobURL = window.URL.createObjectURL(blob)
    // 创建隐藏<a>标签进行下载
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', filename+'.xlsx')
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink) // 移除dom元素
    window.URL.revokeObjectURL(blobURL) // 释放bolb内存
  }
}
// 附件导出方法中处理ZIP文件的部分
export function downloadFileByUrl(fileUrl:string){
  console.log(fileUrl)
  if (!fileUrl) {
    ElMessage.error('下载地址无效');
    return;
  }

  try {
    const link = document.createElement('a');
    link.href = fileUrl;
    const urlParts = fileUrl.split('/');
    const fileName = urlParts[urlParts.length - 1];
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('下载失败', error);
  }
};
export function encryptPublic(str: string, kind = 'phone') {
  if (!str) return ''
  if (kind == 'name') {
    return str.substr(0, 1) + '*'
  }
  if (kind == 'idcard') {
    return str.replace(/^(.{6})(?:\d+)(.{4})$/, '$1********$2')
  }
  if (kind == 'phone') {
    return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  }
}
/**
 *  获取一段时间所有的年月份
 *  @param {String} startDate 开始时间
 *  @param {String} endDate 结束时间
 *  @return {Array} 数组
 */
export function getAllMonth(startDate: string, endDate: string) {
  const start = new Date(startDate)
  const end = new Date(endDate)

  // 计算两个日期之间相差的总月份数
  const yearDiff = end.getFullYear() - start.getFullYear()
  const monthDiff = end.getMonth() - start.getMonth()
  const totalMonthDiff = yearDiff * 12 + monthDiff

  // 获取所有月份
  const allMonths: string[] = []
  for (let i = 0; i <= totalMonthDiff; i++) {
    const d = new Date(start.getFullYear(), start.getMonth() + i, 1)
    const year: string | number = d.getFullYear()
    let month: string | number = d.getMonth() + 1
    month = month < 10 ? '0' + month : month
    allMonths.push(year + '-' + month)
  }

  return allMonths
}
export function autoWidthFunc(ws, data) {
  // set worksheet max width per col
  const colWidth = data.map((row) =>
    row.map((val) => {
      // if null/undefined
      if (val == null) {
        return { wch: 10 }
      } else if (val.toString().charCodeAt(0) > 255) {
        // if chinese
        return { wch: val.toString().length * 3.2 }
      } else {
        return { wch: val.toString().length }
      }
    })
  )

  // start in the first row
  const result = colWidth[0]
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j].wch < colWidth[i][j].wch) {
        result[j].wch = colWidth[i][j].wch
      }
    }
  }
  ws['!cols'] = result
}
export function jsonToArray(key, jsonData) {
  return jsonData.map((v) =>
    key.map((j) => {
      return v[j]
    })
  )
}
export function groupBy(arr, propName) {
  const result = {}
  for (const item of arr) {
    const key = propName(item)
    if (!result[key]) {
      result[key] = [item]
    } else {
      result[key].push(item)
    }
  }
  return result
}
export function disableNode(arr) {
  return arr.map((obj) => {
    // 复制所有属性到一个新对象中
    const newObj = Object.assign({}, obj)

    // 如果 store 为 0，则设置 disabled 为 true
    if (newObj.store === 0) {
      newObj.disabled = true
    }

    // 如果孩子数组存在，则递归调用此函数
    if (newObj.children) {
      newObj.children = disableNode(newObj.children)
    }

    return newObj
  })
}
export function disableNode2(arr) {
  return arr.map((obj) => {
    // 复制所有属性到一个新对象中
    const newObj = Object.assign({}, obj)

    // 如果 is_distributor 为 1，则设置 disabled 为 true
    // 导购禁用 只放开非导购
    if (newObj.is_distributor && newObj.is_distributor == 1) {
      newObj.disabled = true
    }

    // 如果孩子数组存在，则递归调用此函数
    if (newObj.children) {
      newObj.children = disableNode2(newObj.children)
    }

    return newObj
  })
}
export function disableNode3(arr,type) {
  arr.forEach(node => {
    if(type==1){
      node.disabled = true;
    }else if(type==2){
      node.disabled = false;
    }
    if (node.children && node.children.length) {
      disableNode3(node.children,type);
    }
  });
}
export function disableNode4(arr) {
  return arr.map((obj) => {
    // 复制所有属性到一个新对象中
    const newObj = Object.assign({}, obj)

    // 如果 store 为 0，则设置 disabled 为 true
    if (newObj.isParents && newObj.isParents==1) {
      newObj.disabled = true
    }

    // 如果孩子数组存在，则递归调用此函数
    if (newObj.children) {
      newObj.children = disableNode4(newObj.children)
    }

    return newObj
  })
}
export function updateLabels(a, b) {
  const map = {}

  // 遍历 a 数组，将所有对象按照 field 的编号大小存储在 map 对象中
  for (let i = 0; i < a.length; i++) {
    map[a[i].field] = a[i]
  }

  // 遍历 b 数组，如果 map 中已有对应的对象，则比较它们的 label 属性值是否相同，如果不同则修改 map 中的属性
  for (let i = 0; i < b.length; i++) {
    const field = b[i].field
    if (field in map) {
      if (map[field].label !== b[i].label) {
        map[field].label = b[i].label
      }
    } else {
      map[field] = b[i] // 将新的对象加入 map
    }
  }

  // 将 map 中的所有对象转成数组形式，然后按照 field 编号升序排列
  const result = Object.values(map).sort((a, b) => {
    return +a.field.substring(4) - +b.field.substring(4)
  })

  // 将 b 数组中不存在的项过滤掉
  const filteredResult = result.filter((item) => b.some((obj) => obj.field === item.field))

  // 将 b 数组中缺少的项插入到末尾
  const missingItems = b.filter((item) => !result.some((obj) => obj.field === item.field))
  filteredResult.push(...missingItems)
  const [first, ...orther] = a
  filteredResult.unshift(first)
  return filteredResult
}

// 获取 本周 开始日期和结束日期
export function getWeekStartAndEndDate(date) {
  const currentDate = date || new Date();
  const currentDayOfWeek = currentDate.getDay(); // 0 (Sunday) - 6 (Saturday)
  const startDate = new Date(currentDate);
  const endDate = new Date(currentDate);
 
  // 计算当前周的开始日期（周一）
  startDate.setDate(startDate.getDate() - currentDayOfWeek + 1);
 
  // 计算当前周的结束日期（周日）
  endDate.setDate(endDate.getDate() - currentDayOfWeek + 7);
 
  // 格式化日期为年月日
  function formatDate(date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
 
  return {
    start: formatDate(startDate),
    end: formatDate(endDate),
  };
}
